/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useRef } from 'react'
import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider'
import { Color, Chart } from 'chart.js'
import { DropdownFilterDate } from '../../../content/dropdown/DropdownFilterDate' // module "c:/Projects/VDSoftware/AISenseUs/Api/Dashboard/src/_metronic/partials/content/dropdown/Dropdown1"
import { Rating } from '../../../content/Rating'
import { LanguageHelp } from '../../../../helpers/LanguageHelper'
import { getHappinessScore } from '../../../../helpers/utility'
import React from 'react'
var countChart = 0

export class CardsWidget17Dto { "allCount" = -1; "firstCount" = 0; "secondCount" = 0; "thirdCount" = 0; "firstRate" = 0; "secondRate" = 0; "thirdRate" = 0; "rate" = 0; }

type Props = {
  id: string
  className: string
  name?: string
  title?: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
  symbol?: string
  firstText?: string
  secondText?: string
  thirdText?: string
  firstColor?: string
  secondColor?: string
  thirdColor?: string
  rate?: number
  data?: CardsWidget17Dto
  functionSubmit?: any
}

export function getColor(color: string) {
  return "#" + color;
}

const CardsWidget17: FC<Props> = ({
  id,
  className,
  chartSize = 90,
  chartLine = 11,
  chartRotate = 145,
  title = "Projects Earnings in April",
  name = "Projects Earnings in April",
  symbol = "$",
  firstText = "Leaf CRM",
  secondText = "Mivy App",
  thirdText = "Others",
  firstColor = "47be7d",
  secondColor = "f1416c",
  thirdColor = "e4e6ef",
  data = new CardsWidget17Dto(),
  functionSubmit
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const [previusData, updatePreviusData] = React.useState(new CardsWidget17Dto());

  useEffect(() => {
    refreshChart()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  })

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    if (JSON.stringify(previusData) === JSON.stringify(data)) {
      return
    }

    updatePreviusData(data)

    setTimeout(() => {
      initChart(id, chartSize, chartLine, chartRotate, firstColor, secondColor, thirdColor, firstText, secondText, thirdText, data)
    }, 10)
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <span className='card-label fw-bold text-dark'>{title}</span>
          <div>
            <span className='text-gray-400 fw-semibold fs-6'>{name}:</span>
            {data.allCount !== -1 && data.allCount !== 0 &&
              <div style={{ display: 'unset' }}>
                <span className='fs-4 fw-semibold text-gray-400 me-1 align-self-start'>{symbol}</span>
                <span className='card-label fw-bolder text-gray-700 mt-2 pt-1'>{data.allCount}</span>
                <Rating rate={data.rate} />
              </div>
            }
          </div>
        </div>
        <DropdownFilterDate functionSubmit={functionSubmit} />

      </div>

      {data.allCount === -1 &&
        <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
          <div className='d-flex flex-center me-5 pt-2'>
            <span className='indicator-progress' style={{ display: 'block', margin: 'auto' }}>
              {/* Please wait...{' '} */}
              <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
              <div
                style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
              ></div>
            </span>
          </div>
        </div>
      }

      {data.allCount !== -1 &&
        <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
          <div className='d-flex flex-center me-5 pt-2'>
            <div
              id={id}
              ref={chartRef}
              style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
              data-kt-size={chartSize}
              data-kt-line={chartLine}
            ></div>
          </div>

          <div className='d-flex flex-column content-justify-center flex-row-fluid'>
            <div className='d-flex fw-semibold align-items-center'>
              <div className='bullet w-8px h-3px rounded-2 bg-success me-3' style={{ backgroundColor: getColor(firstColor) }}></div>
              <div className='text-gray-500 flex-grow-1 me-4'>{firstText}</div>
              <div className='fw-bolder text-gray-700 text-xxl-end'>{data.firstCount}</div>
              <Rating rate={data.firstRate} />
            </div>
            <div className='d-flex fw-semibold align-items-center my-3'>
              <div className='bullet w-8px h-3px rounded-2 me-3' style={{ backgroundColor: getColor(secondColor) }}></div>
              <div className='text-gray-500 flex-grow-1 me-4'>{secondText}</div>
              <div className='fw-bolder text-gray-700 text-xxl-end'>{data.secondCount}</div>
              <Rating rate={data.secondRate} reversed={true} />
            </div>
            <div className='d-flex fw-semibold align-items-center'>
              <div
                className='bullet w-8px h-3px rounded-2 me-3' style={{ backgroundColor: getColor(thirdColor) }}
              ></div>
              <div className='text-gray-500 flex-grow-1 me-4'>{thirdText}</div>
              <div className=' fw-bolder text-gray-700 text-xxl-end'>{data.thirdCount}</div>
              <Rating rate={data.thirdRate} />
            </div>
          </div>
        </div>

      }

      <div className='card-footer pt-5 pb-5'>
        <span className='text-gray-400 fw-semibold fs-6'>{LanguageHelp('Happiness Score')}:</span>
        {data.allCount !== -1 && data.secondCount !== 0 &&
          <div style={{ display: 'unset' }}>
            <span className='card-label fw-bolder text-gray-700'>{getHappinessScore(data.firstCount, data.secondCount)}</span>
            <Rating rate={data.rate} />
          </div>
        }

      </div>
    </div>
  )
}

const initChart = function (
  id: string,
  chartSize: number = 90,
  chartLine: number = 11,
  chartRotate: number = 145,
  firstColor: string = "47be7d",
  secondColor: string = "f1416c",
  thirdColor: string = "e4e6ef",
  firstText: string = "Leaf CRM",
  secondText: string = "Mivy App",
  thirdText: string = "Others",
  data: CardsWidget17Dto = new CardsWidget17Dto()
) {
  const el = document.getElementById(id)
  if (!el) {
    return
  }
  if (countChart === data.allCount)
    return
  el.innerHTML = ''
  countChart = data.allCount
  var options = {
    size: chartSize,
    lineWidth: chartLine,
    rotate: chartRotate,
    firstColor: firstColor,
    secondColor: secondColor,
    thirdColor: thirdColor,
    firstText: firstText,
    secondText: secondText,
    thirdText: thirdText,
    data: data,
  }

  const canvas = document.createElement('canvas')
  const span = document.createElement('span')
  canvas.width = canvas.height = options.size
  // @ts-ignore
  if (typeof G_vmlCanvasManager !== 'undefined') {
    // @ts-ignore
    G_vmlCanvasManager.initElement(canvas)
  }

  const ctx = canvas.getContext('2d')

  let myChart = new Chart(canvas, {
    type: 'pie',
    data: {
      labels: [firstText, secondText, thirdText],
      datasets: [{
        backgroundColor: [
          getColor(firstColor),
          getColor(secondColor),
          getColor(thirdColor)
        ],
        data: [data.firstCount, data.secondCount, data.thirdCount]
      }]
    },
    options: {
      plugins: {
        legend: {
          display: false
        }
      }
    }
  });
  el.appendChild(span)
  el.appendChild(canvas)
}

export { CardsWidget17 }

